export const OAUTH_URL = "https://api.edx.org/oauth2/v1/access_token";

// LMS URL Paths
export enum AuthApiPath {
  UserLogin = "/api/user/v2/account/login_session/",
  CsrfToken = "/csrf/api/v1/token",
  RegUser = "/api/user/v2/account/registration",
  RegFieldValidation = "/api/user/v1/validation/registration",
  Mfe3rdPartyContext = "/api/mfe_context",
  PasswordResetTokenValidate = "/user_api/v1/account/password_reset/token/validate/",
  PasswordReset = "/password/reset/", // Requires final slash
  ReqForgotPasswordEmail = "/account/password",
  UserAccount = "/api/user/v1/accounts",
  UserLanguage = "/api/user-language",
}

export const REQUIRES_SLASH: AuthApiPath[] = [
  AuthApiPath.RegUser,
  AuthApiPath.PasswordReset,
] as const;

// Content Types
export const CONTENT_TYPE_FORM = "application/x-www-form-urlencoded";
export const CONTENT_TYPE_JSON = "application/json";
export const API_ACCEPT = "application/json, text/plain, */*";

export const AUTH_QUERY_PARAMS = [
  "course_id",
  "enrollment_action",
  "course_mode",
  "email_opt_in",
  "purchase_workflow",
  "next",
  "register_for_free",
  "track",
  "is_account_recovery",
  "variant",
  "host",
  "cta",
];

export const APP_NAME = "rv_edx";

// Taken from edX AuthN, used for local validation before sending to server
export const VALID_EMAIL_REGEX = // Kept as string due to size of regex
  "(^[-!#$%&'*+/=?^_`{}|~0-9A-Z]+(\\.[-!#$%&'*+/=?^_`{}|~0-9A-Z]+)*" +
  '|^"([\\001-\\010\\013\\014\\016-\\037!#-\\[\\]-\\177]|\\\\[\\001-\\011\\013\\014\\016-\\177])*"' +
  ")@((?:[A-Z0-9](?:[A-Z0-9-]{0,61}[A-Z0-9])?\\.)+)(?:[A-Z0-9-]{2,63})" +
  "|\\[(25[0-5]|2[0-4]\\d|[0-1]?\\d?\\d)(\\.(25[0-5]|2[0-4]\\d|[0-1]?\\d?\\d)){3}\\]$";

export const VALID_USERNAME_REGEX = /^[a-zA-Z0-9_-]*$/i;

// Name validation regexes from edX AuthN
export const CONTAINS_URL_REGEX =
  /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/i;
export const CONTAINS_HTML_REGEX = /<|>/u;
export const INVALID_NAME_REGEX = /https?:\/\/(?:[-\w.]|(?:%[\da-fA-F]{2}))/g;

// Custom regexes for password validation, logic from edX AuthN UI
export const CONTAINS_LETTER_REGEX = /[a-zA-Z]/i;
export const CONTAINS_NUMBER_REGEX = /\d/;
